<div>
    <h1>
        {{item.name}}
    </h1>
    <h2>
        {{item.sales}}
    </h2>
</div>